<template>
  <div
    class="card border-round-bottom-2xl border-2 border-gray-300 border-top-none p-5"
  >
    <div class="text-xl text-900 mb-3 underline">
      {{ $t("coordonnees.myDetails") }}
    </div>
    <div id="infos_generales" class="md:col-4">
      <div class="text-xl text-900 font-medium mb-3">
        {{ civilite }} {{ nom }} {{ prenom }}
      </div>
      <div class="text-xl mb-3">{{ metier }}</div>
      <div class="text-xl mb-3">{{ tel }}</div>
      <div class="text-xl mb-3" style="color: #c4165a;">{{ mailClient }}</div>
    </div>
    <div class="flex gap-2">
      <Button
        id="modifier_infos"
        :label="$t('coordonnees.modifyDetails')"
        @click="modifInfos()"
      />
      <Button
        id="modifier_mail"
        :label="$t('coordonnees.modifyEmail')"
        @click="modifMail()"
      />
      <Button
        id="modifier_mdp"
        :label="$t('coordonnees.modifyPassword')"
        @click="modifUser()"
      />
    </div>
  </div>
  <Toast />
  <Button
    class="fixed border-circle shadow-2 bg-blue-500 hover:bg-blue-700 text-white text-xl flex align-items-center justify-content-center"
    style="bottom: 20px; right: 20px; z-index: 9999"
    @click="launchGuide('compte_coordonnees')"
  >
    ?
  </Button>
</template>
<script>
import { startTour } from "@/guide/guide";

export default {
  data() {
    return {
      prenom: null,
      nom: null,
      tel: null,
      mailClient: null,
      civilite: null,
      metier: null,
      idDolibarr: null,
      address: null,
      ville: null,
    };
  },
  mounted() {
    //récupération des informations stockées dans le localStorage et affichés dans les coordonnées de l'utilisateru connecté
    this.prenom = localStorage.getItem("prenom");
    this.nom = localStorage.getItem("nom");
    this.tel = localStorage.getItem("tel");
    this.metier = localStorage.getItem("metier");
    this.civilite = localStorage.getItem("civilite");

    this.mailClient = localStorage.getItem("mail");
    //récupération de l'identifiant Dolibarr
    // pour le moment inutilisé
    // ultérieurement l'utilisateur pourra modifier les informations de Dolibarr
    this.idDolibarr = localStorage.getItem("idDolibarr");
    localStorage.setItem("contactModifIdLocal", localStorage.getItem("idBDD"));
    localStorage.setItem("contactModifIdDolibarr", this.idDolibarr);
    //récupération du token backend dans le local storage
    this.token = localStorage.getItem("token");
  },
  methods: {
    launchGuide(guideContext) {
      startTour(guideContext, this.$i18n.locale);
    },
    //pour la modification du mot de passe de l'utilisateur
    modifUser() {
      //on renseigne le mail de l'utilisateur à modifier
      localStorage.setItem("contactModifMail", this.mailClient);
      //puis on le redirige vers la page de modification
      this.$router.push("/modifUtilisateur");
    },
    modifInfos() {
      //on renseigne le mail de l'utilisateur à modifier
      localStorage.setItem("contactModifMail", this.mailClient);
      //puis on le redirige vers la page de modification
      this.$router.push("/modifInfos");
    },
    modifMail() {
      //on renseigne le mail de l'utilisateur à modifier
      localStorage.setItem("contactModifMail", this.mailClient);
      //puis on le redirige vers la page de modification
      this.$router.push("/modifMail");
    },
  },
};
</script>
